import { IntentAndGuid, MobileAndGuid } from "@core/models/common.interface";
import { userCredentialsDTO } from "@core/models/dto.models";
import {
  PersonalDetails,
  RegistrationState,
  RegistrationStatuses,
} from "@core/models/registration.interface";
import { createSelector } from "@ngrx/store";

export const selectRegistrationFeature = (state: {
  registration: RegistrationState;
}) => state.registration;
export const selectRegistrationState = createSelector(
  selectRegistrationFeature,
  (state) => state
);

export const selectRegistrationPhoneNumberAndGuid = createSelector(
  selectRegistrationFeature,
  (state) => {
    return {
      mobile: state.data.mobile.number,
      guid: state.data.guid,
    } as MobileAndGuid;
  }
);
export const selectRegistrationIntentAndNumber = createSelector(
  selectRegistrationFeature,
  (state) => {
    return {
      intent: state.intent,
      guid: state.data.guid,
    } as IntentAndGuid;
  }
);

export const selectRegistrationIntent = createSelector(
  selectRegistrationFeature,
  (state) => state.intent
);

export const selectRegistrationOtpValidation = createSelector(
  selectRegistrationFeature,
  (state) => state.otpMatch
);
export const selectRegistrationOtpSent = createSelector(
  selectRegistrationFeature,
  (state) => state.otpSent
);

export const selectEmailValidationState = createSelector(
  selectRegistrationFeature,
  (state) => state.validEmail
);
export const selectPassword = createSelector(
  selectRegistrationFeature,
  (state) => state.data.accountCredentials
);
export const selectRegistrationStatuses = createSelector(
  selectRegistrationFeature,
  (state) => {
    return {
      isLoading: state.isLoading,
      finalCheckPassed: state.validEmail,
    } as RegistrationStatuses;
  }
);
export const selectLoginDetails = createSelector(
  selectRegistrationFeature,
  (state) => {
    return {
      email: state.data.email,
      password: state.data.accountCredentials.password,
    } as userCredentialsDTO;
  }
);

//Form selectors

export const selectPersonalDetails = createSelector(
  selectRegistrationFeature,
  (state) => {
    return {
      personalInfo: state.data.personalInfo,
      mobile: state.data.mobile,
    } as PersonalDetails;
  }
);
